/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Tab_ConsumeInputs */

const en_admin_credits_tab_consume = /** @type {(inputs: Admin_Credits_Tab_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consume`)
};

const zh_admin_credits_tab_consume = /** @type {(inputs: Admin_Credits_Tab_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消费`)
};

/**
* | output |
* | --- |
* | "Consume" |
*
* @param {Admin_Credits_Tab_ConsumeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_tab_consume = /** @type {((inputs?: Admin_Credits_Tab_ConsumeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Tab_ConsumeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_tab_consume(inputs)
	return zh_admin_credits_tab_consume(inputs)
});
export { admin_credits_tab_consume as "admin.credits.tab_consume" }